// Added by Sejune Oh on 2019-03-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { Fragment } from 'react'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime elements
import { TableCell } from '@/components/_primes'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
import { TableHeaderPartialProps } from '../../TableContainer'

interface NormalTableHeaderFCProps extends TableHeaderPartialProps {}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const NormalTableHeader = (props: NormalTableHeaderFCProps) => {
    const { customColSpan } = props
    return (
        <Fragment>
            {props.headerProps.map(({ align, disablePadding, label }, index) => (
                <TableCell
                    style={{ paddingRight: 12, paddingLeft: 12 }}
                    colSpan={customColSpan ? customColSpan[index] : 2}
                    key={index}
                    align={align}
                    padding={disablePadding ? 'none' : 'normal'}
                    sortDirection={false}
                    title={label}
                >
                    {label}
                </TableCell>
            ))}
        </Fragment>
    )
}

export default NormalTableHeader
